module.exports = __webpack_public_path__ + "static/media/ArenaSport_Pan Balcani.3456eac7.png";